module.exports = __webpack_public_path__ + "fonts/Helios.22dab50c.eot";